<div class="pop-modal-container"
     *ngIf="modalIsOpen"
     (click)="closeModal()">
  <div class="pop-modal box-layout import-modal"
       (click)="$event.stopPropagation()">

    <div class="pop-modal-body box-layout-child full-width">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>



<div class="structure-modal">


  <div *ngIf="currentEstimate"
       class="structure-dialog">

    <div class="dialog-title structure-dialog-title">{{ "TOOLBAR.STRUCTURE" | translate }}
      <pop-select [options]="projectTemplates"
                  *popFeature="Flags.deactivateModelDropdownStructure"
                  [(selectedOption)]="currentEstimate.projectModelCode"></pop-select>
    </div>

    <div class="structure-toolbar">
      <button class="structure-button"
              *ngIf="currentEstimate.projectModelCode"
              (click)="openImportDialog()"
              [ngClass]="{ 'read-only': isReadOnly }"
              [disabled]="isReadOnly"
              style="display: flex; flex-direction: row; margin-right: 20px">
        <i class="far fa-file-import"
           [ngStyle]="{ color: isReadOnly ? '#E3E3E3' : '#5391cd' }"></i>
        <div style="margin-left: 8px"
             translate="TOOLBAR.IMPORT"></div>
      </button>


      <div style="display: flex; flex-direction: row">
        <button class="structure-button"
                style="margin-right: 1em"
                (click)="addLevel1()"
                [ngClass]="{ 'read-only': isReadOnly }"
                *ngIf="!currentEstimate.projectModelCode">
          <i class="far fa-plus"
             [ngStyle]="{ color: isReadOnly ? '#e3e3e3' : '#5391cd' }"></i>
          <div style="margin-left: 8px"
               [ngStyle]="{ color: isReadOnly ? '#e3e3e3' : '#333333' }"
               translate="MODAL.LVL1"></div>
        </button>
        <button class="structure-button"
                style="margin-right: 1em"
                (click)="addLevel2()"
                *ngIf="isLevel2 && !currentEstimate.projectModelCode"
                [ngClass]="{ 'read-only': isReadOnly }">
          <i class="far fa-plus"
             [ngStyle]="{ color: isReadOnly ? '#e3e3e3' : '#5391cd' }"></i>
          <div style="margin-left: 8px"
               [ngStyle]="{ color: isReadOnly ? '#e3e3e3' : '#333333' }"
               translate="MODAL.LVL2"></div>
        </button>
        <button class="structure-button"
                style="margin-right: 1em"
                *ngIf="selectedNode"
                (click)="copyNode(selectedNode); openSnackBar(selectedNode.label, '')">
          <i class="far fa-copy"
             style="color: #5391cd"> </i>
          <div style="margin-left: 8px"
               translate="BUTTON.COPY"></div>
        </button>
        <button class="structure-button"
                style="margin-right: 1em"
                *ngIf="selectedNode"
                (click)="pasteNode(copiedNode)">
          <i class="far fa-paste"
             style="color: #5391cd"> </i>
          <div style="margin-left: 8px"
               translate="BUTTON.PASTE"></div>
        </button>
        <button class="structure-button"
                style="margin-right: 1em"
                *ngIf="selectedNode"
                (click)="duplicateNode(selectedNode)">
          <i class="far fa-clone"
             style="color: #5391cd"> </i>
          <div style="margin-left: 8px"
               translate="BUTTON.DUPLICATE"></div>
        </button>
        <button class="structure-button"
                (click)="confirmDelete()"
                *ngIf="selectedNode && selectedNode.data.isNew">
          <i class="far fa-trash-alt"
             style="color: #5391cd"> </i>
          <div style="margin-left: 8px"
               translate="BUTTON.DELETE"></div>
        </button>
      </div>

      <div class="pop-display-flex"
           style="flex-direction: row">
        <button class="structure-button"
                *ngIf="isExpandHidden"
                (click)="expandAll()">
          <i class="far fa-expand-alt"
             [matTooltip]="'TOOLTIP.EXPAND' | translate"
             position="below">
          </i>
        </button>
        <button class="structure-button"
                *ngIf="!isExpandHidden"
                (click)="collapseAll()">
          <i class="far fa-compress-alt"
             [matTooltip]="'TOOLTIP.COLLAPSE' | translate"
             position="below">
          </i>
        </button>
      </div>
    </div>

    <div class="structure-headers">
      <span class="sublevel-header"
            translate="HEADER.SUBLEVELS"></span>
      <span style="width: 3rem"
            translate="HEADER.STATUS"></span>
      <span translate="STRUCTURE_MODAL.CATEGORY_GROUP"></span>
      <span translate="TOOLBAR.LUMP_SUM"></span>
      <span translate="MODAL.MAX_BUDGETED"></span>
      <span translate="STRUCTURE_MODAL.LABOR_BILLING_METHOD"></span>
    </div>

    <div class="structure-container">
      <div class="level1-node"
           *ngFor="let level1Node of level1Tree">
        <div class="level-row"
             [ngClass]="{ highlight: currentEstimate.structureDepth === 'Level2' }">
          <div class="level-col">
            <i class="far fa-chevron-right"
               *ngIf="
                expandedLevel1Ids.indexOf(level1Node.data.id) === -1 &&
                level1Node.children.length > 0
              "
               (click)="expandNode(level1Node)"></i>
            <i class="far fa-chevron-down"
               *ngIf="
                expandedLevel1Ids.indexOf(level1Node.data.id) !== -1 &&
                level1Node.children.length > 0
              "
               (click)="collapseNode(level1Node)"></i>
            <form (ngSubmit)="updateNode(level1Node)"
                  #newNode1="ngForm"
                  (keyup.enter)="updateNode(level1Node)">
              <div class="form-group pop-display-flex"
                   style="flex-wrap: wrap"
                   *ngIf="showInputs(level1Node)"
                   #newNodeLevel1>
                <input #code
                       autocomplete="off"
                       maxlength="11"
                       size="5"
                       style="text-transform: uppercase"
                       required
                       [disabled]="
                    isReadOnly ||
                    (currentEstimate.estimateType !== 'New' &&
                      !level1Node.data.isNew)
                  "
                       class="code-input"
                       type="text"
                       placeholder="Code"
                       [ngModel]="level1Node.data.code"
                       (ngModelChange)="hasDuplicate($event, level1Node)"
                       name="level1Code"
                       tabindex="1" />
                <span class="dot-input">&#8901;</span>
                <input autocomplete="off"
                       class="desc-input"
                       maxlength="30"
                       size="12"
                       type="text"
                       required
                       placeholder="Description"
                       [(ngModel)]="level1Node.data.description"
                       name="level1Desc"
                       tabindex="2" />
              </div>
            </form>

            <span class="level-select"
                  tabindex="-1"
                  *ngIf="!showInputs(level1Node)"
                  [ngClass]="{
                selected: showSelected(level1Node),
                unselected: !showSelected(level1Node),
                'struct-read-only': isReadOnly
              }"
                  (click)="nodeSelect(level1Node)"
                  (dblclick)="editSubLevel(level1Node)">
              <span style="text-transform: uppercase; font-weight: 500">{{
                level1Node.data.code
                }}</span>
              <span class="dot">&#8901;</span>
              <span style="text-transform: uppercase; font-weight: 500">{{
                level1Node.data.description
                }}</span>
            </span>
          </div>
          <span class="switch-col"
                style="width: 3rem">
            <div class="pop-display-flex"
                 style="flex-direction: column; gap: 5px">
              <button *ngIf="level1Node.data.isNew"
                      class="new-row"
                      translate="STATUS.NEW"></button>
              <button *ngIf="
                  level1Node.data.isNew &&
                  problematicSublevels?.problematicSubLevel1Codes?.includes(
                    level1Node.data.code
                  )
                "
                      class="error-row"
                      [matTooltip]="'TOOLTIP.NEW_LEVEL_EXISTS' | translate"
                      position="below"
                      (click)="ignoreLevelWarning(level1Node)">
                <i class="far fa-exclamation-triangle"></i>
                {{ "BUTTON.CONFLICT" | translate }}
              </button>
            </div>
          </span>
          <span class="switch-col">
            {{ level1Node | categoryCode: currentEstimate }}
          </span>
          <div class="switch-col">
            <label class="switch">
              <input type="checkbox"
                     #level1LumpSum
                     id="level1LumpSum"
                     name="lumpSum"
                     (change)="confirmLumpSum(level1LumpSum, level1Node)"
                     [disabled]="
                  isLumpSumToggleDisabled(
                    getIsMaxBudgetedForToggle(level1Node),
                    getIsUsingLaborBillingMethodForToggle(level1Node)
                  )
                "
                     [checked]="getIsLumpSumForToggle(level1Node)" />
              <span class="slider round"
                    [ngClass]="{
                  inactive: isLumpSumToggleDisabled(
                    getIsMaxBudgetedForToggle(level1Node),
                    getIsUsingLaborBillingMethodForToggle(level1Node)
                  )
                }"></span>
            </label>
          </div>
          <div class="switch-col">
            <label class="switch">
              <input type="checkbox"
                     #level1MaxBudgeted
                     id="level1MaxBudgeted"
                     name="maxBudgeted"
                     (change)="confirmMaxBudgeted(level1MaxBudgeted, level1Node)"
                     [disabled]="
                  isMaxBudgetedToggleDisabled(getIsLumpSumForToggle(level1Node))
                "
                     [checked]="getIsMaxBudgetedForToggle(level1Node)" />
              <span class="slider round"
                    [ngClass]="{
                  inactive: isMaxBudgetedToggleDisabled(
                    getIsLumpSumForToggle(level1Node)
                  )
                }"></span>
            </label>
          </div>
          <div class="switch-col">
            <label class="switch">
              <input type="checkbox"
                     (change)="confirmUsingLaborBillingMethod($event, level1Node)"
                     name="level1LaborBillingMethodCode"
                     #level1LaborBillingMethodCode
                     [checked]="getIsUsingLaborBillingMethodForToggle(level1Node)"
                     [disabled]="
                  isLaborBillingMethodToggleDisabled(
                    getIsLumpSumForToggle(level1Node)
                  )
                " />
              <span class="slider round"
                    [ngClass]="{
                  inactive: isLaborBillingMethodToggleDisabled(
                    getIsLumpSumForToggle(level1Node)
                  )
                }"></span>
            </label>
          </div>
        </div>
        <div *ngIf="isLevel2">
          <ng-container *ngIf="expandedLevel1Ids.indexOf(level1Node.data.id) !== -1">
            <div class="level2-node"
                 *ngFor="let level2Node of level1Node.children">
              <div class="level-row">
                <div class="level-col">
                  <form (ngSubmit)="updateNode(level2Node)"
                        style="padding-left: 1rem"
                        (keyup.enter)="updateNode(level2Node)"
                        #newNode="ngForm">
                    <div class="form-group pop-display-flex"
                         *ngIf="showInputs(level2Node)"
                         style="flex-wrap: wrap"
                         #newNodeLevel2>
                      <input #code
                             autocomplete="off"
                             maxlength="11"
                             size="5"
                             required
                             class="code-input"
                             id="level2Code"
                             type="text"
                             [disabled]="
                          isReadOnly ||
                          (currentEstimate.estimateType !== 'New' &&
                            !level2Node.data.isNew)
                        "
                             placeholder="Code"
                             [ngModel]="level2Node.data.code"
                             (ngModelChange)="hasDuplicate($event, level2Node)"
                             name="level2Code"
                             style="text-transform: uppercase" />
                      <span class="dot-input">&#8901;</span>
                      <input autocomplete="off"
                             class="desc-input"
                             maxlength="30"
                             size="12"
                             type="text"
                             required
                             placeholder="Description"
                             [(ngModel)]="level2Node.data.description"
                             name="level2Desc" />
                    </div>
                  </form>
                  <span class="level-select"
                        tabindex="-1"
                        *ngIf="!showInputs(level2Node)"
                        (click)="nodeSelect(level2Node)"
                        [ngClass]="{
                      selected: showSelected(level2Node),
                      unselected: !showSelected(level2Node),
                      'struct-read-only': isReadOnly
                    }"
                        (dblclick)="editSubLevel(level2Node)">
                    <span style="text-transform: uppercase">
                      {{ level2Node.data.code }}
                    </span>
                    <span class="dot">&#8901;</span>
                    <span>{{ level2Node.data.description }}</span>
                    <span *ngIf="!showInputs(level2Node)"></span>
                  </span>
                </div>
                <span class="switch-col"
                      style="width: 3rem">
                  <div class="pop-display-flex"
                       style="flex-direction: column; gap: 5px">
                    <button *ngIf="level2Node.data.isNew"
                            class="new-row"
                            translate="STATUS.NEW"></button>
                    <button *ngIf="
                        !level1Node.data.isNew &&
                        level2Node.data.isNew &&
                        problematicSublevels?.problematicSubLevel2Codes[
                          level1Node.data.code
                        ]?.includes(level2Node.data.code)
                      "
                            class="error-row"
                            [matTooltip]="'TOOLTIP.NEW_LEVEL_EXISTS' | translate"
                            position="below"
                            (click)="ignoreLevelWarning(level2Node)">
                      <i class="far fa-exclamation-triangle"></i>
                      {{ "BUTTON.CONFLICT" | translate }}
                    </button>
                  </div>
                </span>
                <span class="switch-col">
                  {{ level1Node | categoryCode: currentEstimate:level2Node }}
                </span>
                <div class="switch-col">
                  <i class="fas fa-exclamation-circle"
                     *ngIf="(currentEstimate.laborBillingMethodCode === '' || null)
                            && !getIsLumpSumForToggle(level1Node, level2Node)"
                     [matTooltip]="'TOOLTIP.N2_METHOD' | translate"
                     position="below"></i>
                  <label class="switch">
                    <input type="checkbox"
                           #level2LumpSum
                           name="level2-lump-sum"
                           class="billingMethod-checkbox"
                           (change)="
                        changeIsLumpSumToggle(
                          level2LumpSum,
                          false,
                          level1Node,
                          level2Node
                        )
                      "
                           [disabled]="
                        isLumpSumToggleDisabled(
                          getIsMaxBudgetedForToggle(level1Node, level2Node),
                          getIsUsingLaborBillingMethodForToggle(
                            level1Node,
                            level2Node
                          )
                        )
                      "
                           [checked]="getIsLumpSumForToggle(level1Node, level2Node)" />
                    <span class="slider round"
                          [ngClass]="{
                        inactive: isLumpSumToggleDisabled(
                          getIsMaxBudgetedForToggle(level1Node, level2Node),
                          getIsUsingLaborBillingMethodForToggle(
                            level1Node,
                            level2Node
                          )
                        )
                      }"></span>
                  </label>
                </div>
                <div class="switch-col">
                  <label class="switch">
                    <input type="checkbox"
                           #level2MaxBudgeted
                           id="level2MaxBudgeted"
                           name="maxBudgeted"
                           class="billingMethod-checkbox"
                           (change)="
                        changeMaxBudgetedToggle(
                          level2MaxBudgeted,
                          false,
                          level1Node,
                          level2Node
                        )
                      "
                           [disabled]="
                        isMaxBudgetedToggleDisabled(
                          getIsLumpSumForToggle(level1Node, level2Node)
                        )
                      "
                           [checked]="
                        getIsMaxBudgetedForToggle(level1Node, level2Node)
                      " />
                    <span class="slider round"
                          [ngClass]="{
                        inactive: isMaxBudgetedToggleDisabled(
                          getIsLumpSumForToggle(level1Node, level2Node)
                        )
                      }"></span>
                  </label>
                </div>
                <div class="switch-col">
                  <label class="switch">
                    <input type="checkbox"
                           #level2LaborBillingMethodCode
                           id="level2LaborBillingMethodCode"
                           name="level2LaborBillingMethodCode"
                           class="billingMethod-checkbox"
                           (change)="
                        changeIsUsingLaborBillingMethodToggle(
                          $event,
                          false,
                          level1Node,
                          level2Node
                        )
                      "
                           [disabled]="
                        isLaborBillingMethodToggleDisabled(
                          getIsLumpSumForToggle(level1Node, level2Node)
                        )
                      "
                           [checked]="
                        getIsUsingLaborBillingMethodForToggle(
                          level1Node,
                          level2Node
                        )
                      " />
                    <span class="slider round"
                          [ngClass]="{
                        inactive: isLaborBillingMethodToggleDisabled(
                          getIsLumpSumForToggle(level1Node, level2Node)
                        )
                      }">
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
